<script lang="ts" setup>
interface ImageAttributes {
    align?: "center" | "left" | "right" | "justify";
    alt?: string;
    border?: string;
    borderTop?: string;
    borderBottom?: string;
    borderLeft?: string;
    borderRight?: string;
    borderRadius?: string;
    containerBackgroundColor?: string;
    cssClass?: string;
    fluidOnMobile?: "true" | "false";
    height?: string;
    href?: string;
    name?: string;
    padding?: string;
    paddingBottom?: string;
    paddingLeft?: string;
    paddingRight?: string;
    paddingTop?: string;
    rel?: string;
    sizes?: string;
    src?: string;
    srcset?: string;
    target?: "_blank" | "_self" | "_parent" | "_top";
    title?: string;
    usemap?: string;
    width?: string;
}

const props = withDefaults(defineProps<ImageAttributes>(), {
    align: "center",
    alt: "",
    border: "none",
    borderTop: "none",
    borderBottom: "none",
    borderLeft: "none",
    borderRight: "none",
    borderRadius: undefined,
    containerBackgroundColor: undefined,
    cssClass: undefined,
    fluidOnMobile: undefined,
    height: "auto",
    href: undefined,
    name: undefined,
    padding: "10px 25px",
    paddingBottom: undefined,
    paddingLeft: undefined,
    paddingRight: undefined,
    paddingTop: undefined,
    rel: undefined,
    // sizes: undefined,
    src: undefined,
    srcset: undefined,
    target: "_blank",
    title: undefined,
    width: "100%",
});

const attributes = computed(() => {
    return {
        container: {
            align: props.align,
            style: {
                backgroundColor: props.containerBackgroundColor,
                padding: props.padding,
                paddingBottom: props.paddingBottom,
                paddingLeft: props.paddingLeft,
                paddingRight: props.paddingRight,
                paddingTop: props.paddingTop,
            },
        },
        cell: {
            align: props.align,
            style: {
                width: props.width,
            },
        },
        anchor: {
            rel: props.rel,
            href: props.href,
            target: props.target,
            name: props.name,
        },
        image: {
            title: props.title,
            src: props.src,
            srcset: props.srcset,
            height: props.height,
            alt: props.alt,
            align: props.align,
            style: {
                border: props.border,
                borderRadius: props.borderRadius,
                height: props.height,
                width: props.width,
            },
        },
    };
});
</script>
<template>
    <div :class="cssClass">
        <div v-bind="attributes.container">
            <div
                border="0"
                cellpadding="0"
                cellspacing="0"
                role="presentation"
                style="vertical-align: top"
                width="100%"
            >
                <div>
                    <div>
                        <div v-bind="attributes.cell">
                            <template v-if="$slots.default && !src">
                                <slot />
                            </template>
                            <a v-else-if="href" v-bind="attributes.anchor">
                                <img v-bind="attributes.image" />
                            </a>
                            <img v-else v-bind="attributes.image" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
